import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter, MatterPropertyDamage } from "@/lib/types";
import { type ReactNode } from "react";

interface MatterPropertyDamageContextMenuProps {
  canDelete: boolean;
  id: string;
  isDeleting: boolean;
  label?: string | null;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  propertyDamage: MatterPropertyDamage;
  trigger: ReactNode;
}

export const MatterPropertyDamageContextMenu = ({
  canDelete,
  id,
  isDeleting,
  label,
  matter,
  onDelete,
  onEdit,
  propertyDamage,
  trigger,
}: MatterPropertyDamageContextMenuProps) => {
  const entityLabel = label || "property damage";

  return (
    <MatterSubItemContextMenu
      copyValue={[
        entityLabel,
        propertyDamage.originalAmount != null
          ? `Original amount: $${propertyDamage.originalAmount}`
          : undefined,
      ]
        .filter(Boolean)
        .join("\n")}
      delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
      entityLabel={entityLabel}
      entityName="property damage"
      matter={matter}
      onEdit={onEdit}
      subItem={{ id, type: "property-damage" }}
      trigger={trigger}
    />
  );
};
